import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Félicitations ! Vous avez gagné {{amount}} en cashback.',
  },
};
